module.exports = __webpack_public_path__ + "97727f8ebefa52379a3f7be849c68bd9.jpg";